<div class="p-4">
  <h5 *ngIf="!vote" class="m-3">Choose from the following and submit your vote</h5>
  <h5 *ngIf="vote" class="m-3">Choose from the following to change your vote.  Any supporting information from the previous vote will be lost once you cast your new vote.  If required, please attach supporting information in the field below.</h5>

  <button id="modal-close-icon" class="absolute right-4 top-4" (click)="cancel()">
    <span class="text-lg material-symbols-rounded text-grey-800">close</span>
  </button>
  <mat-divider class="m-3 border-gray-300"></mat-divider>

  <form [formGroup]="voteOptionForm" class="flex flex-col gap-4">
    <div
      class="flex items-stretch justify-between w-full gap-2 p-4 text-gray-700 children:w-1/3 children:flex-1 children:children:h-full body-default-regular">

      <div class="p-4 border border-gray-400 rounded-md"
        [ngClass]="{'border-blue-400 bg-blue-50 text-black' : reconfirmSelect?.value}">
        <div class="flex flex-col ">
          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2 text-2xl">{{reconfirm.text}}</div> <div class="material-symbols-rounded" [ngStyle]="{'color': reconfirm.color}">{{reconfirm.icon}}</div>
            </div>
            <div >
                <label for="reconfirmBtn" class="flex items-center cursor-pointer">
                  <span class="mr-2">Select</span>
                  <input
                    type="checkbox"
                    id="reconfirmBtn"
                    name="reconfirmSelectCtrl"
                    (click)="selectReconfirm()"
                    formControlName="reconfirmSelectCtrl"
                    class="mr-1"
                  />
                </label>
            </div>
          </div>

          <mat-divider class="border-gray-300 "></mat-divider>
          <div class="h-3/4" [ngClass]="{'pointer-events-none': !reconfirmSelect?.value}">
            <div class="mt-2">
              <p>
                Select this option where the publication remains technically valid, can be used for the intended purpose
                and
                still delivers a net benefit to the Australian community. For more information on Net Benefit please
                refer to
                our <a class="text-blue-500 cursor-pointer underline" href="https://www.standards.org.au/getmedia/74d21a82-6b8c-41da-833b-4fad0a8b0d82/Guide-to-Net-Benefit-GU-103.aspx" target="_blank">Guide to Net Benefit</a>.
              </p>
              <p>
                Do not select this option if the existing technical content can no longer be used. Do not select this
                option
                if the publication is an adoption of an International publication which is now Superseded or Withdrawn.
              </p>
              <p>
                The outcome will be that the publication will remain "Current" until the next review cycle, although it
                may be
                revised before that date.
              </p>

            </div>
            <div class="flex flex-row mt-2 mb-4 ml-6">
              <div class="">
                <input  type="checkbox" id="reconfirmCurrentPublicationConfirmationCtrl" name="reconfirmCurrentPublicationConfirmationCtrl"
                formControlName="reconfirmCurrentPublicationConfirmationCtrl" class="mr-1" />
              </div>

              <div class="ml-2">
               <label for="reconfirmCurrentPublicationConfirmationCtrl">
                 I believe this document is suitable to remain as Current publication without any changes to its content. I acknowledge that the publication does not
                 contain
                 any technical errors, that it is fit for purpose within its scope, and that it continues to deliver net
                 benefit to the Australian community.
               </label>
              </div>
            </div>

          </div>
          <div class="mt-2">
            <p>{{noteTitle}}</p>
            <app-text-area id="reconfirm-note" formControlName="reconfirmNoteCtrl" [displayCharactersCount]="false" placeholder={{noteTitle}}></app-text-area>
          </div>

        </div>
      </div>

      <div class="p-4 border border-gray-400 rounded-md"
            [ngClass]="{'border-blue-400 bg-blue-50 text-black' : reviseSelect?.value}">
        <div class="flex flex-col ">
          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2 text-2xl">{{revise.text}}</div> <div class="material-symbols-rounded" [ngStyle]="{'color': revise.color}">{{revise.icon}}</div>
            </div>
            <div >
              <label for="reviseBtn" class="flex items-center cursor-pointer">
                <span class="mr-2">Select</span>
                <input
                  type="checkbox"
                  id="reviseBtn"
                  name="reviseSelectCtrl"
                  (click)="selectRevise()"
                  formControlName="reviseSelectCtrl"
                  class="mr-1"
                />
              </label>
            </div>
          </div>


          <mat-divider class="border-gray-300 "></mat-divider>
          <div class="h-3/4" [ngClass]="{'pointer-events-none': !reviseSelect?.value}">
            <div class="mt-2">
              <p>
                Select this option if the technical content is no longer suitable for use, however the publication is
                still
                needed and there is support to Revise it.
              </p>
              <p>
                This may be because the technical content is no longer valid, if it no longer reflects current practice,
                if it
                is not suitable for new and existing applications, or if it is not compatible with current views and
                expectations regarding quality, safety or the environment.
              </p>
              <p>
                The outcome will be that the publication will be marked “Pending Revision” for a period of 12 months.
                A valid Project Proposal to Revise the publication must be submitted within this period. If a valid
                proposal
                is not submitted, the publication will be Withdrawn at the end of the period.
              </p>
            </div>
            <div class="flex flex-col items-start mt-2 mb-2">
              Would you be willing to lead the project proposal development?
              <div class="mt-2">
                 <input type="radio" id="reviseSelectionBtn" name="leadProjectProposalCtrl" value="yes"
                    formControlName="leadProjectProposalCtrl" class="mr-1" checked />
                  <label for="reviseSelectionBtn">Yes</label>
              </div>
              <div>
                   <input type="radio" id="reviseSelectionNoBtn" name="leadProjectProposalCtrl" value="no"
                    formControlName="leadProjectProposalCtrl" class="mr-1" checked />
                  <label for="reviseSelectionNoBtn">No</label>
              </div>
            </div>

          </div>
          <div class="mt-2">
            <p>{{noteTitle}}</p>
            <app-text-area id="revise-note" formControlName="reviseNoteCtrl" [displayCharactersCount]="false" placeholder={{noteTitle}}></app-text-area>
          </div>

        </div>
      </div>

      <div class="p-4 border border-gray-400 rounded-md"
        [ngClass]="{'border-blue-400 bg-blue-50 text-black' : withdrawSelect?.value}">
        <div class="flex flex-col ">
          <div class="flex justify-between mb-4">
            <div class="flex font-bold">
              <div class="mr-2 text-2xl">{{withdraw.text}}</div> <div class="material-symbols-rounded" [ngStyle]="{'color': withdraw.color}">{{withdraw.icon}}</div>
            </div>
            <div >
              <label for="withdrawBtn" class="flex items-center cursor-pointer">
                <span class="mr-2">Select</span>
                <input
                  type="checkbox"
                  id="withdrawBtn"
                  name="withdrawSelectCtrl"
                  (click)="selectWithdraw()"
                  formControlName="withdrawSelectCtrl"
                  class="mr-1"
                />
              </label>
            </div>
          </div>

          <mat-divider class="border-gray-300 "></mat-divider>
          <div class="h-3/4" [ngClass]="{'pointer-events-none': !withdrawSelect?.value}">
            <div class="">
              <p>
                Select this option if the existing document is no longer needed. Often the technical content is no
                longer
                suitable for use.
              </p>
              <p>
                This may be because the technical content is no longer valid, if it no longer reflects current practice,
                if it
                is not suitable for new and existing applications, or if it is not compatible with current views and
                expectations regarding quality, safety or the environment.
              </p>
              <p>
                The outcome will be the publication will be marked “Withdrawn”. It will remain available for purchase,
                but it
                will no longer be maintained by the committee.
              </p>
              <p>
                Please note: It is still possible, however, for a Withdrawn Standard to be used within an industry,
                community
                or by a government if they choose to do so. One reason for this may be because there are no replacement
                technical
                documents readily available.
              </p>

            </div>

          </div>
          <div class="mt-2">
            <p >{{noteTitle}}</p>
            <app-text-area id="withdraw-note" formControlName="withdrawNoteCtrl" [displayCharactersCount]="false" placeholder={{noteTitle}}></app-text-area>
          </div>
        </div>
      </div>


    </div>

    <div id="file-upload-supporting-information" class="flex flex-col flex-grow p-4">
      <files-upload
        title="Attach supporting information"
        accept=".pdf,.zip,.doc,.docx,.png,.rtf,.tif,.txt,.msg"
        formControlName="supportingInformationCtrl"
        [progress]="supportingInformationUploadProgress"
      ></files-upload>
    </div>
  </form>

  <div class="flex justify-end gap-6 mt-5 mb-5 mr-10">
    <button class="px-8 py-3 border border-black btn btn-neutral" id="SRS-vote-Cancel-Button" (click)="cancel()"
      type="button">Cancel</button>
    <button class="px-8 py-3 btn btn-primary" id="SRS-place-vote-Button" [disabled]="!isFormValid" (click)="placeVote()">Submit</button>
  </div>
</div>
